import React from 'react';
import {
  OptionShimmer,
  CircleShimmer,
  DetailShimmer,
  TitleShimmer,
  DescriptionShimmer,
  WrapperShimmer,
  Shimmer
} from './styled';

export const TypeOperationRadioInputShimmer: React.FC = () => (
  <WrapperShimmer>
    <OptionShimmer>
      <CircleShimmer><Shimmer /></CircleShimmer>
      <DetailShimmer>
        <TitleShimmer><Shimmer /></TitleShimmer>
        <DescriptionShimmer><Shimmer /></DescriptionShimmer>
      </DetailShimmer>
    </OptionShimmer>
    <OptionShimmer>
      <CircleShimmer><Shimmer /></CircleShimmer>
      <DetailShimmer>
        <TitleShimmer><Shimmer /></TitleShimmer>
        <DescriptionShimmer><Shimmer /></DescriptionShimmer>
      </DetailShimmer>
    </OptionShimmer>
  </WrapperShimmer>
);